import { BrowserRouter } from "react-router-dom";
import { LocalizationProvider } from "@rshbintech.dboul/utils";
import { useCallback, useState } from "react";
import { PerformanceTracker } from "../common/utils/performance";
import { AuthProvider } from "../auth-provider";
import { AppLocale } from "../common/types";
import { translations } from "../translations";
import { UserInterfaceAccessGuardProvider } from "../common/user-interface-access-guard-deprecated";
import { ClientSettingsProvider } from "../common/client-settings";
import { MassActionPolling } from "../common/mass-action-polling";
import { Layout } from "./layout";

PerformanceTracker.init();

export const AppLayout = () => {
  /**
   * Связь между провайдерами двух независимых модулей, т.к. AuthProvider может встраиваться отдельно, например на login-ui
   */
  const [appLanguage, setAppLanguage] = useState<AppLocale>();

  const handleLanguageChange = useCallback(
    async (language: AppLocale) => setAppLanguage(language),
    []
  );

  return (
    <AuthProvider language={appLanguage}>
      <UserInterfaceAccessGuardProvider>
        <MassActionPolling>
          <ClientSettingsProvider>
            <LocalizationProvider<AppLocale>
              fallBackLanguage="ru_RU"
              resources={translations}
              language={appLanguage}
              defaultNamespace="COMMON"
              onLanguageChange={handleLanguageChange}
            >
              <BrowserRouter>
                <Layout />
              </BrowserRouter>
            </LocalizationProvider>
          </ClientSettingsProvider>
        </MassActionPolling>
      </UserInterfaceAccessGuardProvider>
    </AuthProvider>
  );
};
